import templateUrl from "servicestack/data-files/data-file-container.htm";
import controller from "servicestack/data-files/data-file-container.controller";

export default {
  bindings: {
    simple: "<?",
    detailRoute: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
